module.exports = __webpack_public_path__ + "img/newyear.6b1411fc.jpg";